import React from 'react'
import propTypes from 'prop-types'
import {connect} from 'react-redux'
import StringHelper from 'helpers/string'
import {getRegionalLocale} from 'selectors/settings'

const NumberString = (props) => {
    const {children, precision, locale} = props
    return (<span className="numberString">{StringHelper.formatNumber(children, locale, precision)}</span>)
}

NumberString.propTypes = {
    children: propTypes.oneOfType([
        propTypes.string,
        propTypes.number,
    ]).isRequired,
    locale: propTypes.string.isRequired,
    precision: propTypes.number,
}

NumberString.defaultProps = {
    precision: 0,
    locale: 'en-gb',
}

const mapStateToProps = (state) => {
    return {
        locale: getRegionalLocale(state),
    }
}

export default connect(mapStateToProps)(NumberString)
